module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/app-banner-phone-57aa58947cb5f10fcdb73175652e6652.png";